"use client"

import { Coins } from "lucide-react"
import Link from "next/link"

interface CreditCounterProps {
  credits: number
  planRemaining?: number
  walletCredits?: number
  showBreakdown?: boolean
}

export function CreditCounter({ credits, planRemaining, walletCredits, showBreakdown }: CreditCounterProps) {
  const shouldShowBreakdown = showBreakdown && planRemaining !== undefined && walletCredits !== undefined

  return (
    <div className="relative group">
      <Link
        href="/dashboard?tab=billing"
        className="flex items-center space-x-2 text-gray-700 hover:text-[#40A1AB] transition-colors"
      >
        <Coins className="h-5 w-5" />
        <span className="text-sm font-medium">{credits} credits</span>
      </Link>

      {shouldShowBreakdown && (
        <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 px-4 py-3 bg-gray-900 text-white text-sm rounded-lg shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap z-[9999]">
          <div className="space-y-1">
            <div className="flex justify-between items-center gap-4">
              <span className="text-gray-300">Plan:</span>
              <span className="font-medium">{planRemaining}</span>
            </div>
            <div className="flex justify-between items-center gap-4">
              <span className="text-gray-300">Wallet:</span>
              <span className="font-medium">{walletCredits}</span>
            </div>
            <div className="border-t border-gray-600 pt-1 mt-2">
              <div className="flex justify-between items-center gap-4">
                <span className="text-gray-300">Total:</span>
                <span className="font-semibold text-white">{credits}</span>
              </div>
            </div>
          </div>
          <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 border-4 border-transparent border-b-gray-900"></div>
        </div>
      )}
    </div>
  )
}
